export interface CreateUser
{
    firstName:string,
    lastName:string,
    displayName:string,
    userName:string,
    password:string,
    applicationRoles:any[],
    province:number,
    branch:number,
    organization: string,
    isActive:boolean,
    age:number|null;
}

export function createuserdefaultvalues():CreateUser
{
    return {firstName:'',lastName:'',displayName:'',userName:'',password:'',applicationRoles:[],province:0,branch:0,organization:'',isActive:true,age:null};   
}